export default __webpack_public_path__ + "static/media/ion_time-outline.8a398859.svg";